import React, { useState, useEffect, useRef  } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import { Col, Form, Row } from 'react-bootstrap';
import { Checkbox } from 'primereact/checkbox';



export default function SchoolParameters(props) {
    const toast = useRef(null);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [studentsCanLogin, setStudentsCanLogin] = useState(true);
    const [loading, setLoading] = useState(false);

    
    useEffect(() => {
      setLoading(true);
      var params = {login:util.getTrustedUser()};
      var url = config.Server+`/school/school/setting/parameters/list`;
      console.log("params---->", params)
      console.log("url---->", url)
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  for(var i=0;i<response.length;i++){
                    if(response[i].name == "StudentsCanLogin") setStudentsCanLogin((response[i].value == "true")||(response[i].value == ""));
                  }
                  setLoading(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setLoading(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setLoading(false);
          });
    }, []);

    const saveSetting = function(){
      setLoading(true);
      var paramNames = ["StudentsCanLogin"];
      var paramValues = [studentsCanLogin?"true":"false"];
      var params = {login:util.getTrustedUser(), paramNames, paramValues:paramValues};
      var url = config.Server+`/school/school/setting/parameters/save`;
      console.log("params---->", params)
      console.log("url---->", url)
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  setErrorMessage("با موفقيت ثبت گردید");
                  setErorVisible(true);
                  setLoading(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setLoading(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setLoading(false);
          });

    }
    return(      
      <>
         <div className="page-caption" style={{ width:"calc(100% - 0px)"}}>تنظیمات و پارامترها</div>
         <div style={{width:"calc(100% - 0px)"}}>
            <Row>
              <Col md={6}>
                  <div className="flex align-items-center" style={{marginTop:"10px"}}>
                      <Checkbox inputId="chk1" onChange={(e)=>{setStudentsCanLogin(e.checked)}} checked={studentsCanLogin} />
                      <label htmlFor="chk1" className="ml-2"> &nbsp;دانش آموزان و اولیا می توانند وارد سامانه شوند</label>
                  </div>                
              </Col>
            </Row>
            <Row style={{marginTop:"20px"}}>
              <Col md={3} style={{padding:"10px"}}>
                <div className="flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
                  <Button label="ثبت تنطیمات" icon="pi pi-plus" onClick={()=>saveSetting()} severity="success" iconPos="right" loading={loading} style={{width:"200px"}} />                  
                </div>
              </Col>
            </Row>
         </div>
          <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
            <Toast ref={toast} />
      </>  
    );
  
}
